import React from 'react'
import PropTypes from 'prop-types'

const RegionToggle = ({ selected, changeHandler }) => {

  const region = require('../../../../static/data/region.json')

  const regionOptions = Object.keys(region).sort().map(value =>
    <option key={value} value={ value }>{value}</option>
  );

  return (
    <div className="cmwf--region-select--group">
      <label htmlFor="cmwf--region-select">Region</label>
      {' '}
      <select
        id="cmwf--region-select"
        className="select__small"
        onChange={e => changeHandler(e.target.value)}
        defaultValue={selected}
      >
        <option value="">-- All Regions --</option>
        { regionOptions }
      </select>
    </div>
  )
}

RegionToggle.propTypes = {
  selected: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired,
}

export default RegionToggle



// WEBPACK FOOTER //
// ./src/components/Visualizations/components/region-toggle.jsx